/*
 Data Layer Events
 1. Page View
 - Collections (DONE)
  - event "gs-view-item-list"
 - PDP (DONE - View Item )
  - event "gs-view-item"
 2. Click Events (DONE)
  - event "gs-click-event"
 3. Cart Events
  - Add (DONE)
    - event "gs-add-to-cart"
  - Remove (DONE)
    - event "gs-remove-from-cart"
  - View (DONE)
    - event "gs-view-cart"
 - Add To Cart
 4. Desktop Navigation Hover Event
*/

const cartDatalayerPush = async (eventType) => {
  try {
      const response = await fetch('/cart.js');
      const data = await response.json();
      console.log(data);

      let eventName = "";
      let eventKey = "";

      switch(eventType) {
          case 'view':
              eventName = "view_cart";
              eventKey = "view-cart";
              break;
          case 'add':
              eventName = "add_to_cart";
              eventKey = "add-to-cart";
              break;
          case 'remove':
              eventName = "remove_from_cart";
              eventKey = "remove-from-cart";
              break;
          default:
              console.error(`Unknown event type: ${eventType}`);
              return;
      }

      const ga4Items = data.items.map((item, index) => ({
          event: eventName,
          item_id: item.sku,
          item_name: item.title,
          affiliation: "Grunt Style",
          coupon: (item.discounts.length >= 1 ? item.discounts[0].title : ""),
          discount: parseFloat((item.total_discount / 100).toFixed(2)),
          index: index,
          item_brand: item.vendor,
          item_category: item.product_type,
          item_variant: item.variant_title,
          price: parseFloat((item.price / 100).toFixed(2)),
          quantity: item.quantity
      }));

      const cartObj = {
          [`gs-${eventKey}`]: {
              currency: data.currency,
              value: parseFloat((data.total_price / 100).toFixed(2)),
              items: ga4Items
          }
      };

      console.log(cartObj);
      window.dataLayer.push('event', cartObj);
  } catch (error) {
      console.error('Error fetching or processing cart data:', error);
  }
};

const extractCollectionName = (url) => {
    let collectionStart = "/collections/";
    let productStart = "/products/";
    
    // Check if the URL includes "/collections/" and does not include "/products/"
    if (url.includes(collectionStart) && !url.includes(productStart)) {
        const startIndex = url.indexOf(collectionStart) + collectionStart.length;
        const collectionName = url.substring(startIndex).split('/')[0];
        return collectionName;
    } else if (url.includes(collectionStart) && url.includes(productStart)) {
        const startIndex = url.indexOf(collectionStart) + collectionStart.length;
        const endIndex = url.indexOf(productStart);
        const collectionName = url.substring(startIndex, endIndex);
        return collectionName;
    } else if ( url.includes("search") ) {
      return "search";
    } else {
        return null;
    }
}

const removeQueryString = (url) => {
  let urlObj = new URL(url);
  return urlObj.origin + urlObj.pathname;
};

const extractProductData = (url) => {  
  const scriptElement = document.querySelector('script[type="application/ld+json"]');
  
  if (scriptElement) {
    let productData = JSON.parse(scriptElement.textContent);
    if (productData['@type'] === "Product") {      
      let productInfo = {
        'gs-view-item': {
          event: 'view_item',
          item_name: productData.name,
          image: productData.image[0],
          price: productData.offers[0].price,
          currency: productData.offers[0].priceCurrency,
          item_id: productData.sku,
          item_list_id: (url.includes('/collections/') ? extractCollectionName(url) : 'direct'),
          item_list_name: (url.includes('/collections/') ? extractCollectionName(url) : 'Direct'),
          availability: productData.offers[0].availability,
          url: removeQueryString(productData.offers[0].url),
          affiliation: productData.brand.name,
          quantity: 1
        }        
      };
      console.log(productInfo)
      return productInfo;
    }      
  } else {
    return null;
  }
}

const collectionsProductCards = (url) => {  
  const productCards = (url.includes("search") ? document.querySelectorAll('.product-cart-item.aos-init') : document.querySelectorAll('.product-card-item'));
  let collectionsData = [];
  productCards.forEach(card => {      
      let productDetailsJson = card.getAttribute('data-product-details-json');        
      try {        
        let productDetails = JSON.parse(productDetailsJson);              
        collectionsData.push(extractCollectionsData(url, productDetails));
      } catch (error) {
        console.error('Error parsing JSON:', error, 'Product JSON:', productDetailsJson);
      }      
  });
  let collectionsObj = {
    'gs-view-item-list': {
      item_list_id: (url.includes('/collections/') ? extractCollectionName(url) : 'direct'),
      item_list_name: (url.includes('/collections/') ? extractCollectionName(url) : 'Direct'),
      items: collectionsData
    }
  }
  console.log(collectionsObj);
  window.dataLayer.push('event', collectionsObj);
}

const observeProductList = (url) => {
  const productList = document.querySelector('#CollectionProductsParent .product-card-wrapper .container .row');  
  const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
          if (mutation.type === 'childList') {              
            collectionsProductCards(url);
          }
      });
  });  
  const config = { childList: true, subtree: true };  
  if (productList) {
      observer.observe(productList, config);
  }
}

const extractCollectionsData = (url, productData) => {  
  let productInfo = 
    {
      event: 'view_item_list',
      item_name: productData.title,
      image: productData.featured_image,
      price: (productData.price / 100).toFixed(2),
      currency: window.Shopify.currency.active,
      item_id: productData.variants[0].sku,
      item_list_id: (url.includes('/collections/') ? extractCollectionName(url) : 'direct'),
      item_list_name: (url.includes('/collections/') ? extractCollectionName(url) : 'Direct'),
      availability: productData.available,
      url: `https://gruntstyle.com/products/${url}`,
      affiliation: productData.vendor,
      quantity: 1    
  };
  return productInfo;
}

const getSearchTerm = (url, key) => {
  try {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      return params.get(key);
  } catch (error) {
      console.error('Invalid URL:', error);
      return null;
  }
}

const extractHoverEvent = (el) => {  
  let hoverObj = {
    'gs-navigation-hover' : {
      event: 'hover',
      navigation_item: el
    }
  }
  console.log(hoverObj);
  window.dataLayer.push('event', hoverObj);
}

window.dataLayer = window.dataLayer || [];
window.addEventListener('DOMContentLoaded', (event) => {
  let url = window.location.pathname;  
  // PDP
  if ( url.includes('/products/') ){
    window.dataLayer.push('event', extractProductData(url));
  }
  // Collections
  if ( url.includes('collections') && !url.includes('products') ){
    collectionsProductCards(url);
    observeProductList(url);
  }
  // SRP
  if ( url.includes('search') ){    
    collectionsProductCards(url);
    observeProductList(url);
    let searchObj = {
      'gs-search-event' : {
        event: 'search',
        search_term: getSearchTerm(window.location.href, 'q')
      }
    }
    console.log(searchObj);
    window.dataLayer.push('event', searchObj);
  }
});
document.addEventListener('click', function(event) {
    let targetElement = event.target;
    // Find the closest anchor or button element
    let closestAnchorOrButton = targetElement.closest('a, button, input, details');
    if (closestAnchorOrButton) {
      console.log('Anchor, button, input or details summary clicked:', closestAnchorOrButton);
      let label = closestAnchorOrButton.getAttribute('title') || closestAnchorOrButton.getAttribute('aria-label');      
      if (label) {
        let cleanLabel = label.trim().toLowerCase().replace(/\s+/g, '-');
        let dataObj = {
          'gs-click-event' : {
            event: 'click',
            element: closestAnchorOrButton,
            label: cleanLabel,
            type: closestAnchorOrButton.tagName.toLowerCase(),
            selectors: Array.from(closestAnchorOrButton.classList).join(' '),
            href: (closestAnchorOrButton.getAttribute('href') !== null ? closestAnchorOrButton.getAttribute('href') : ''),
            url: window.location.href,
            customer: ( window.customer_logged_in != false ? `customer-${window.customer_email}` : `visitor` )
          }
        }
        window.dataLayer.push('event', dataObj);
        console.log('Data layer event pushed:', dataObj);
      }
      let href = closestAnchorOrButton.getAttribute('href');
      if (href && href === "#ajax-cart-drawer") {
          cartDatalayerPush('view');
      }
    } else {      
      let dataObj = {
          'gs-click-event' : {
            event: 'click',
            element: targetElement,
            label: targetElement.innerText,
            type: targetElement.tagName.toLowerCase(),
            selectors: Array.from(targetElement.classList).join(' '),
            href: (targetElement.getAttribute('href') !== null ? targetElement.getAttribute('href') : ''),
            url: window.location.href,
            customer: ( window.customer_logged_in != false ? `customer-${window.customer_email}` : `visitor` )
          }
        }
        window.dataLayer.push('event', dataObj);
        console.log('Data layer All Other Click events pushed:', dataObj);
    }
});